import { HttpParams } from '@angular/common/http';
import { HttpParamObject } from '../data-types/http-types';

/**
 * Can handle single values or arrays.
 * Usage example:
 * myParams = {
 *   ids: [1, 2, 3],
 *   active: true,
 * };
 */
export function appendHttpParams(myParams: HttpParamObject): HttpParams {
  let params = new HttpParams();

  Object.entries(myParams).forEach(([key, value]) => {
    if (value === null || value === undefined) return;

    if (Array.isArray(value)) {
      value.forEach((v) => (params = params.append(key, String(v))));
    } else {
      params = params.append(key, String(value));
    }
  });

  return params;
}
